<template>
  <div v-if="scProductListShow.length && ready">
    <div class="queryJobClassify" v-if="hasJobSelect">
      <a
        class="queryJobClassify ml_12"
        target="__blank"
        @click="jobPickingOpen = true"
        >查詢職業類別 ></a
      >
    </div>
    <!-- 職業分類POP -->
    <job-picking-modal
      :open="jobPickingOpen"
      @submit="submitJob"
      @close="jobPickingOpen = false"
    />
    <div
      class="mfTable__table sc__input mt_5 pb_10"
      :class="{ hasJobSelect: hasJobSelect, isExempt: isExempt }"
    >
      <div class="mfTable__table__head">
        <div class="head__number">編號</div>
        <div class="head__prodname">商品名稱</div>
        <div class="head__period" v-if="!isExempt">繳費<br />年期</div>
        <div class="head__insured">被保險人</div>
        <div class="head__job" v-if="hasJobSelect">職業類別</div>
        <div class="head__membership_tier" v-if="isSpillover">
          「FitBack健康吧」<br />會員等級
        </div>
        <div class="head__amt" v-if="!isExempt">保額/計畫別</div>
        <div class="head__premium" v-if="!isExempt">應繳保費<br />(折減前)</div>
        <div class="head__delete">
          <div class="btn btn-default btn-sm px_2 pt_2" @click="deleteAll()">
            <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
          </div>
        </div>
      </div>
      <div class="mfTable__table__body">
        <div
          class="mfTable__table__body--row"
          v-for="(item, index) in scProductListShow"
          :key="`${uniqueKey}__${item.prod_id}${item.insured_name}`"
          v-show="item.is_checked == '1'"
        >
          <div class="body__number">附約{{ index + 1 }}</div>
          <div class="body__prodname text-left mf-textWrap">
            {{ item.prod_name }}
            <span class="text-nowrap">({{ item.prod_id }})</span>
          </div>
          <div
            class="body__period"
            v-if="!isExempt"
            :class="{ hide: item.free_prod != '0' }"
          >
            {{ item.pay_prd ? mainProduct.pay_prd : "1" }}年
          </div>
          <div class="body__insured">{{ truncate(item.insured_name, 12) }}</div>
          <!-- 職業類別 -->
          <div class="body__job" v-if="hasJobSelect">
            <!-- <div class="errorMessage mb_2">
              {{
                errors.first(
                  `${uniqueKey}__job__${item.prod_id}${item.insured_name}`
                )
              }}
            </div> -->
            <!-- JobSome -->
            <!-- item.rmk ? '' : `checkJob|checkJobSome` -->
            <div class="position-relative" v-if="item.job_ind != '0'">
              <select
                class="form-control"
                style="width: 7rem"
                :id="`${uniqueKey}__job__${item.prod_id}${item.insured_name}`"
                :data-vv-name="`${uniqueKey}__job__${item.prod_id}${item.insured_name}`"
                :class="{
                  'is-invalid':
                    (!JobSome && item.job_cat != '') ||
                    errors.has(
                      `${uniqueKey}__job__${item.prod_id}${item.insured_name}`
                    ),
                }"
                v-validate.continues="{
                  checkJob: true,
                  checkJobSome: !JobSome,
                }"
                data-vv-as="1~6類可投保"
                v-model="item.job_cat"
                @change="itemJobChangeHandler(item)"
              >
                <option value="" disabled>請選擇</option>
                <option
                  v-for="value in item.job_select"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>

          <div class="body__membership_tier" v-if="isSpillover">
            <div
              class="errorMessage mb_2"
              v-if="(item.cwp_level == '1' || item.is_spillover4 == '1') && !isAdulthood"
            ><span>             
               主約被保險人未滿18歲
           </span>

            </div>
            <div class="position-relative d-flex align-items-center">
              <select
                :disabled="!isAdulthood"
                v-if="item.cwp_level == '1' || item.is_spillover4 == '1'"
                class="form-control"
                style="width: 10rem"
                v-model="item.level"
                :id="`${uniqueKey}__membership_tier__${item.prod_id}${item.insured_name}`"
                :data-vv-name="`${uniqueKey}__membership_tier__${item.prod_id}${item.insured_name}`"
                :class="{
                  'is-invalid': errors.has(
                    `${uniqueKey}__membership_tier__${item.prod_id}${item.insured_name}`
                  ),
                }"
                v-validate.continues="`checkMemberShip_${item.prod_id}`"
                @change="itemMembershipTierChangeHandler(item)"
              >
                <option value="" disabled>請選擇</option>
                <option
                  :value="level.paraval"
                  v-for="level in item.level_select"
                  :key="'fit_back_level' + level.paraval"
                >
                  {{ level.paradetlno }}
                </option>
              </select>
            </div>
          </div>

          <!-- 保額&計畫別 -->
          <div class="body__amt py_4" v-if="!isExempt">
            <!-- v-if="
                item.amt_incr_unit !== '0' &&
                !(
                  item.amt_unit == '7' ||
                  item.amt_unit == '8' ||
                  item.col_amt == '1'
                )
              " -->
            <div
              class="errorMessage mb_2"
              v-show="item.amt_floor != item.amt_ceil"
              v-if="
                item.amt_unit != '7' &&
                item.amt_unit != '8' &&
                item.col_amt != '1' &&
                item.amt_incr_unit != '0' &&
                item.amt_incr_unit / item.amt_formatVal != 1
              "
            >
              <!-- 如果amt_unit_nm是"元" 一律不顯示，currTranser第二個參數為true -->
              {{
                `保額需以${item.amt_incr_unit / item.amt_formatVal}${unit_curr(
                  item.amt_unit,
                  item.curr
                )}為單位`
              }}
            </div>
            <div
              class="position-relative d-flex align-items-center"
              v-if="item.free_prod == '0'"
            >
              <select
                class="form-control"
                style="width: 8rem"
                v-model="item.amt"
                :id="`${uniqueKey}__amt__${item.prod_id}${item.insured_name}`"
                :data-vv-name="`${uniqueKey}__amt__${item.prod_id}${item.insured_name}`"
                :class="{
                  'is-invalid': errors.has(
                    `${uniqueKey}__amt__${item.prod_id}${item.insured_name}`
                  ),
                }"
                v-validate.continues="`required|checkAMT_${item.prod_id}`"
                v-if="
                  item.amt_unit == '7' ||
                  item.amt_unit == '8' ||
                  item.col_amt == '1'
                "
                @change="
                  calcPremium(item, $event.target.value.replace(/[^0-9]/gi, ''))
                "
                :disabled="item.job_ind != '0' && !item.job_cat"
              >
                <option value="" disabled>請選擇</option>
                <option
                  :value="amtOption"
                  v-for="amtOption in item.amt_select"
                  :key="amtOption"
                >
                  {{ amtOption }}
                </option>
              </select>
              <input
                v-else
                type="text"
                @input="
                  numberHandler(item, 'amt', $event);
                  calcPremium(
                    item,
                    $event.target.value.replace(/[^0-9]/gi, '')
                  );
                "
                :disabled="
                  item.amt_ceil === item.amt_floor ||
                  (item.job_ind != '0' && !item.job_cat)
                "
                :value="item.amt | formatMethods"
                class="form-control form-control-inline"
                style="max-width: 9.5rem"
                :class="{
                  'is-invalid': errors.has(
                    `${uniqueKey}__amt__${item.prod_id}${item.insured_name}`
                  ),
                }"
                v-validate.continues="`required|checkAMT_${item.prod_id}`"
                :data-vv-name="`${uniqueKey}__amt__${item.prod_id}${item.insured_name}`"
                maxlength="15"
                :placeholder="
                  item.job_ind != '0' && item.job_cat == ''
                    ? ''
                    : `${formatMethods(item.amt_floor_format)}~${formatMethods(
                        item.amt_ceil_format
                      )}`
                "
              />
              <span class="amtInputSpan">{{
                unit_curr(item.amt_unit, item.curr)
              }}</span>
            </div>
          </div>
          <!-- 保費 -->
          <div
            class="body__premium text-right"
            :class="{ hide: item.free_prod != '0' }"
            v-if="!isExempt"
          >
            {{ item.premium ? formatMethods(item.premium) : "0" }}
            {{ currTranser(item.curr, true) }}
          </div>
          <div class="body__delete">
            <div
              class="btn btn-default btn-sm px_2 pt_2"
              @click="deleteHandler(item)"
            >
              <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import mf_Mixin from "@/desktop/views/mf/mixin";
import JobPickingModal from "./JobPickingModal";
// Validator.extend("checkAmt", {
//   getMessage(field, arg) {
//     return `需以${arg[0]}元為單位`;
//   },
//   validate: (value) => {
//     return value != "";
//   },
// });
Validator.extend("checkJob", {
  getMessage(field, arg) {
    return `1~6類可投保`;
  },
  validate: (value) => {
    return value != "";
  },
});
Validator.extend(`checkJobSome`, {
  getMessage: "職業類別需相同",
  validate: (value) => {
    return false;
  },
});
export default {
  props: ["scProductList", "uniqueKey", "mainProduct", "level"],
  mixins: [mf_Mixin],
  components: { JobPickingModal },
  data() {
    return {
      timer: {},
      ready: false,
      jobPickingOpen: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.scProductList.length > 0) {
        //這部分主要是用來作為編輯模式時的檢核

        let scProductListScope = this.scProductList.map((sc) => {
          //調整繳費年期、繳別、年齡後，動態計算保額限制
          let amtRange = sc.amt_ind_list
            ? sc.amt_ind_list.find((item) => {
                let result = true;
                if (item.age_ceil != "-1" || item.age_floor != "-1") {
                  //需判斷年齡上下限
                  if (
                    parseInt(sc.insured_age) < parseInt(item.age_floor) ||
                    parseInt(sc.insured_age) > parseInt(item.age_ceil)
                  ) {
                    result = false;
                  }
                }

                if (item.gender != "-1") {
                  //性別影響上限
                  if (sc.insured_gender != item.gender) {
                    result = false;
                  }
                }
                if (item.reserve_col != "-1" && sc.insured_age != "") {
                  //特殊欄位(到達年齡)影響上限
                  if (sc.insured_age != item.reserve_col) {
                    result = false;
                  }
                }
                return result;
              })
            : {
                amt_ceil: sc.amt_ceil,
                amt_floor: sc.amt_floor,
              };
          //附約預設欄
          sc.amt_formatVal =
            sc.amt_unit != "" ? this.$amtUnitFormat(sc.amt_unit) : 1;

          sc.amt_floor_format = amtRange.amt_floor / sc.amt_formatVal;
          sc.amt_ceil_format = amtRange.amt_ceil / sc.amt_formatVal;

          sc.job_select = [];
          for (let i = sc.job_start; i <= sc.job_end; i++) {
            sc.job_select.push(i);
          }
          if (sc.job_select.length > 0) {
            //配合主附約職業類別連動，附約職業類別保持一致
            let temp_sc_job_cat = sc.job_cat;
            let temp_mc_job_cat =
              this.mainProduct.job_cat != ""
                ? this.mainProduct.job_cat
                : this.mainProduct.temp_job_cat;
            if (
              sc.job_select.some((item) => parseInt(item) == temp_mc_job_cat)
            ) {
              //需在職業類別清單範圍內才更新
              sc.job_cat = temp_mc_job_cat;
              if (temp_sc_job_cat != temp_mc_job_cat) {
                this.itemJobChangeHandler(sc, true);
              }
            }
          }
          //職業類別影響保額上限(2022/03/22新增)
          if (sc.renew_type_list && sc.renew_type_list.length > 0) {
            let renew_type = sc.renew_type_list.find((job) => {
              return job.job_cat == sc.job_cat;
            });
            if (renew_type) {
              //如果職業類別的上限比較低才替換
              if (parseInt(renew_type.amt_ceil) < sc.amt_ceil_format) {
                sc.amt_ceil_format = parseInt(renew_type.amt_ceil);
              }
            }
          }
          if (sc.amt_unit == "7" || (sc.amt_unit == "8" && sc.amt_list == "")) {
            sc.amt_select = [];
            for (
              let i = parseInt(sc.amt_floor_format);
              i <= parseInt(sc.amt_ceil_format);
              i++
            ) {
              sc.amt_select.push(i.toString());
            }
          } else if (sc.amt_list != "") {
            let amt_list_array = sc.amt_list.split(",");
            sc.amt_select = amt_list_array.filter((item) => {
              return item <= sc.amt_ceil_format && item >= sc.amt_floor_format;
            });
          }

          //配合主附約會員等級連動，附約會員等級保持一致
          if (sc.cwp_level == "1" || sc.is_spillover4 == "1") {
            sc.level = this.level;
          }

          sc.pol_period = this.mainProduct.pol_period;
          Validator.extend(`checkAMT_${sc.prod_id}`, {
            getMessage: "保額金額錯誤",
            validate: (value) => {
              let intValue = parseInt(value.split(",").join(""));
              let incr_unit = sc.amt_incr_unit / sc.amt_formatVal;
              return (
                intValue >= sc.amt_floor_format &&
                intValue <= sc.amt_ceil_format &&
                (incr_unit == 0 ? true : intValue % incr_unit == 0)
              );
            },
          });

          Validator.extend(`checkMemberShip_${sc.prod_id}`, {
            getMessage: "會員等級錯誤",
            validate: (value) => {
              if (this.isAdulthood) {
                let memberValue = value.split(",").join("");
                return !isNaN(memberValue) && memberValue !== "";
              } else {
                return true;
              }
            },
          });

          sc.level_select = this.$paragrpno.level_nm;
          sc.level = isNaN(sc.level) ? "" : sc.level;
          return sc;
        });
        //更新父層
        this.$nextTick(() => {
          this.$emit("update_scProductList", scProductListScope);
          this.ready = true;
        });
      } else {
        this.ready = true;
      }
    },
    deleteHandler(target) {
      //實際上只是將is_checked改為false，並隱藏在畫面上，沒有真的刪掉該物件
      target.is_checked = "0";
      this.$forceUpdate();
    },
    deleteAll() {
      this.scProductList.forEach((item) => {
        item.is_checked = "0";
        this.$forceUpdate();
      });
    },
    async calcPremium(item, amt) {
      if (amt == "") {
        return setTimeout(() => {
          item.premium = "0";
        });
      }
      if (this.timer[item.prod_id]) {
        clearTimeout(this.timer[item.prod_id]);
      }
      let incr_unit = item.amt_incr_unit / item.amt_formatVal;
      this.$store.commit("update_canSave", false);
      this.timer[item.prod_id] = setTimeout(() => {
        if (
          item.amt >= item.amt_floor_format &&
          item.amt <= item.amt_ceil_format &&
          (incr_unit == 0 ? true : item.amt % incr_unit == 0)
        ) {
          this.$mfAPI
            .MFC0_1000__getPremium({
              prod_id: item.prod_id,
              insured_age: item.insured_age,
              insured_gender: item.insured_gender,
              pay_prd: !item.pay_prd ? null : this.mainProduct.pay_prd,
              pol_period: this.mainProduct.pol_period || "",
              pay_freq:
                this.mainProduct.prod_type != "1"
                  ? "4"
                  : this.mainProduct.pay_freq, //投資型附約固定呈現年繳保費
              amt: amt,
              pay_dis: this.mainProduct.pay_dis,
              group_dis: this.mainProduct.group_dis,
              job_cat: item.job_cat,
              add_method: this.mainProduct.add_method,
            })
            .then((res) => {
              this.timer[item.prod_id] = null;
              if (item.amt == res.amt) {
                item.premium = res.premium;
                item.computeDiscountPremium = res.discount_premium;
                this.$forceUpdate();
              } else {
                item.premium = "0";
              }
            });
        } else {
          item.premium = "0";
          this.$store.commit("update_canSave", true);
        }
      }, 500);
    },
    async validateAll(needNotice) {
      const checkResult = await this.$validator.validateAll();
      if (!checkResult && needNotice) {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤!",
        });
      }
      return checkResult;
    },
    itemJobChangeHandler(item, isSync = false) {
      if (this.mainProduct.job_cat != "") {
        //配合主附約職業類別連動，更改附約則同步更改主約職業類別
        this.mainProduct.job_cat = item.job_cat;
      } else {
        this.mainProduct.temp_job_cat = item.job_cat;
      }
      if (!isSync) {
        this.init();
      }
      if (item.amt != "") {
        this.$validator.validate(
          `${this.uniqueKey}__amt__${item.prod_id}${item.insured_name}`
        );
        this.calcPremium(item, item.amt);
      }
    },
    itemMembershipTierChangeHandler(item, isSync = false) {
      //配合主附約會員等級連動，更改附約則同步更改主約會員等級
      this.$emit("update:level", item.level);
    },
    submitJob(job) {
      if (parseInt(job.job_cat) > parseInt(this.option.job_option.length)) {
        this.productDataScope.job_cat = "";
      } else {
        this.productDataScope.job_cat = job.job_cat;
      }
      this.jobPickingOpen = false;
    },
  },
  computed: {
    scProductListShow() {
      this.init();
      return this.scProductList.filter((item) => {
        return item.is_checked == "1";
      });
    },
    hasJobSelect() {
      return this.scProductList.some((item) => {
        return item.is_checked == "1" && item.job_ind != "0";
      });
    },
    isExempt() {
      return this.scProductList.every((item) => {
        if (item.is_checked == "1") {
          if (item.free_prod == "0") return false;
          return true;
        } else {
          return true;
        }
      });
    },
    isSpillover() {
      return this.scProductList.some((item) => {
        return (
          this.mainProduct.prod_type == "1" &&
          item.is_checked == "1" &&
          (item.cwp_level == "1" || item.is_spillover4 == "1")
        );
      });
    },
    isAdulthood() {
      return (
        !isNaN(Number(this.$store.getters.MfEditing.insured.insured_age)) &&
        Number(this.$store.getters.MfEditing.insured.insured_age) >= 18
      );
    },
    JobSome() {
      let JobSet = new Set();
      if (this.mainProduct.job_cat) {
        let insured = this.$store.getters.MfEditing.insured;
        let mc = this.mainProduct;
        JobSet.add(
          `${insured.insured_age}${insured.insured_name}${
            insured.insured_gender
          }_job${mc.job_cat}`
        );
      }
      this.scProductListShow.forEach((sc) => {
        if (sc.job_cat != "") {
          JobSet.add(
            `${sc.insured_age}${sc.insured_name}${sc.insured_gender}_job${
              sc.job_cat
            }`
          );
        }
      });
      if (JobSet.size > 1) {
        this.$mfNotice(
          "商品輸入內容有誤或漏填,  請依照畫面文字提示重新輸入或改選擇其他商品!",
          () => {},
          false,
          null,
          "確定",
          "",
          "請注意! 同組建議職業類別需相同!"
        );
        return false;
      }
      return true;
    },
  },
  watch: {
    "mainProduct.pay_prd": {
      handler(value) {
        this.init();
        this.scProductListShow.forEach((item) => {
          if (item.pay_prd) {
            item.pay_prd = value;
          }
          if (item.is_checked == "1") {
            this.calcPremium(item, item.amt);
          }
        });
      },
    },
    "mainProduct.pay_freq": {
      handler(value) {
        this.init();
        this.scProductListShow.forEach((item) => {
          item.pay_freq = value;
          if (item.is_checked == "1") {
            this.calcPremium(item, item.amt);
          }
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// 10 32 8 16 16 12 6
.sc__input {
  width: 100%;
  max-width: 1140px;
  .head__number,
  .body__number {
    width: 9%;
    line-height: 40px;
    height: 40px;
    white-space: nowrap;
  }
  .head__prodname,
  .body__prodname {
    width: 23%;
    padding: 4px 12px !important;
  }
  .head__period,
  .body__period {
    width: 8%;
    &.hide {
      visibility: hidden;
    }
  }
  .head__insured,
  .body__insured {
    width: 12%;
  }
  .head__membership_tier,
  .body__membership_tier {
    width: 14%;
  }
  .head__membership_tier,
  .body__membership_tier {
    width: 15%;
  }
  .head__amt,
  .body__amt {
    width: 18%;
  }
  .head__premium,
  .body__premium {
    width: 12%;
    white-space: normal;
    &.hide {
      visibility: hidden;
    }
  }
  .head__delete,
  .body__delete {
    width: 6%;
  }
  //具有職業別的狀態
  &.hasJobSelect {
    .head__job,
    .body__job {
      width: 13%;
    }
    .head__prodname,
    .body__prodname {
      width: 19%;
    }
  }
  //豁免附約
  &.isExempt {
    max-width: 589px;
    .head__number,
    .body__number {
      width: 18%;
      line-height: 40px;
      height: 40px;
    }
    .head__prodname,
    .body__prodname {
      width: 50%;
    }
    .head__insured,
    .body__insured {
      width: 20%;
    }
    .head__delete,
    .body__delete {
      width: 12%;
    }
  }
  //客製化
  .body__premium {
    color: #063;
    font-size: 18px;
    font-weight: 700;
    white-space: normal;
  }
  //錯誤
  .errorMessage {
    font-size: 13px;
    color: #de4054;
    white-space: nowrap;
  }
}
.queryJobClassify {
  max-width: 904px;
  color: #048f3a;
  text-decoration: underline;
  font-size: 14px;
  text-align: right;
  font-weight: 700;
  cursor: pointer;
}
.amtInputSpan {
  white-space: nowrap;
  display: inline-block;
  margin-left: 4px;
}
</style>
